<template>
	<card ref="card" title="" icon="">
		<div class="error-contents">
			<div class="error-title">インポートエラーがありました</div>
			<div class="body" v-html="body"></div>
			<div class="notice">インポートを中止しました</div>
		</div>

		<div class="buttons">
			<b-button type="is-success" @click="onOkButtonClick">OK</b-button>
		</div>
	</card>
</template>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import DatePicker from '@/components/DatePicker'
import moment from 'moment';

export default {
	name: "ScheduleImportErrorModal",
	components: {
		Card,
		FormField,
		DatePicker,
	},
	props: {
		body: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
		}
	},
	computed: {
	},
	mounted() {
	},
	methods: {
		onOkButtonClick: function() {
			this.$parent.close();
		},
	}
}
</script>

<style lang="scss" scoped>
.field:not(:last-child) {
	margin-bottom: 1.25rem;
}

.card {
	padding: 30px;

	.body {
		height: 200px;
		overflow: scroll;
		margin: 15px 0;
		border: 1px gray solid;
		padding: 10px;
	}

	.buttons {
		margin-top: 1.5rem;
	}
	.buttons button {
		width: 150px;
		margin: 0 auto;
	}
}
</style>
